"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.calcAbsoluteEvent = exports.calcRelativeEvent = void 0;
var validation_1 = require("./validation");
/** Для событий с абсолютными датами возвращает события с относительными смещениями дат */
function calcRelativeEvent(event, base) {
  validation_1.ValueValidation.assertDate('base', base);
  validation_1.ValueValidation.assertDate('begin_at', event.begin_at);
  validation_1.ValueValidation.assertDate('end_at', event.end_at);
  var baseTime = new Date(base).getTime();
  return __assign(__assign({}, event), {
    begin_offset: new Date(event.begin_at).getTime() - baseTime,
    end_offset: new Date(event.end_at).getTime() - baseTime
  });
}
exports.calcRelativeEvent = calcRelativeEvent;
/** Для событий с абсолютными датами возвращает события с относительными смещениями дат */
function calcAbsoluteEvent(event, base) {
  validation_1.ValueValidation.assertDate('base', base);
  validation_1.ValueValidation.assertInteger('begin_offset', event.begin_offset);
  validation_1.ValueValidation.assertInteger('end_offset', event.end_offset);
  var baseTime = new Date(base).getTime();
  return __assign(__assign({}, event), {
    begin_at: new Date(event.begin_offset + baseTime),
    end_at: new Date(event.end_offset + baseTime)
  });
}
exports.calcAbsoluteEvent = calcAbsoluteEvent;
